import axiosInstance from '@/utils/axios';
import Configuration from '@/utils/configuration';
import { handleApiError } from '@/utils/helpers';

const API_HOST = Configuration.value('VUE_APP_API_HOST');

export const login = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`${API_HOST}/authentications`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* create a whitelist token entry for a user id
export const createToken = async (id) => {
  let response = {};

  try {
    response = await axiosInstance.post(`${API_HOST}/whitelist/usertoken/${id}`, undefined);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* delete a whitelist token entry for a user id
export const deleteToken = async (payload) => {
  let response = {};
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  };

  try {
    response = await axiosInstance.delete(`${API_HOST}/whitelist/usertoken/${payload}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* get a whitelist token entry for a user id
export const getToken = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.get(`${API_HOST}/whitelist/usertoken/${payload}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* check token for validity
export const checkToken = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.get(`/me/auth`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
